import AppConfig from "../../../../config/AppConfig";

export default [
  {
    data: [AppConfig.API_URL + "/anim?screen1"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen2"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen3"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen4"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen5"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen6"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen7"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen8"],
    loop: [false],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen9"],
    loop: [false],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen10"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen11"],
    loop: [true],
  },
  {
    data: [AppConfig.API_URL + "/anim?screen12"],
    loop: [true],
  },
];
